<template>
  <div id="center">
	<span class="fs-xl text mx-2 pl-3" style="margin-top: 5px; margin-left: 10px; margin-top: 10px; padding-bottom: 0;">
		<icon name="chart-pie" class="text-icon" style="margin-right: 5px; float: left;"></icon>
		评估干预人数
	</span>
    <div class="down">
      <div class="ranking bg-color-black">
		  <Topchartright></Topchartright>
      </div>
    </div>
  </div>
</template>

<script>
import Topchartright from '@/components/echart/top/toprightchart' // eslint-disable-line no-unused-vars
export default {
  data() {
    return {
        
    }
  },
  components: {
	  Topchartright
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 25%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: auto;
	overflow: hidden;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 100%;
      .dv-scr-rank-board {
        height: 340px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
